import {find, get} from 'lodash';

/*
 * Returns bool representing whether or not the image should be rendered responsively
 */
export const shouldRenderResponsiveImg = (imgExtension) =>
  imgExtension !== 'gif';

export const shouldForceImgAsJpg = (imgExtension, location) => {
  const forcePNGsToJPGs = get(location, 'query.force_pngs_to_jpgs', false);
  if (imgExtension !== 'png' || !forcePNGsToJPGs || forcePNGsToJPGs === 'false') {
    // want to make sure we never force a GIF as a JPG, for instance
    return false;
  }

  if (forcePNGsToJPGs === 'true') {
    return true;
  }

  return true;
};

const browserSupportWebP = () => {
  const elem = document.createElement('canvas');
  if (elem.getContext && elem.getContext('2d')) {
    // checks if the browser is able get the WebP representation
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }
  // old browsers like IE 8 where canvas not supported
  return false;
};

export const shouldForceImgAsWebP = (location, extension) =>
  ['jpeg', 'jpg', 'png'].includes(extension)
  && browserSupportWebP()
  && location.query.force_webp !== 'false';

/*
 * Converts opener image type into the corresponding decimal ratio
 * Ex: '4x3' returns 1.3333
 */
export const openerImageTypeToRatio = (type) => {
  const [w, h] = type.split('x').map(s => parseInt(s));
  return w / h;
};

/*
 * For image sections, thumbnails, and other images for which
 * we know the original asset size, we should not return an
 * image that's larger than the original asset on any side
 */
export const getSafeDimensionsForSection = (width, height, original_width_px, original_height_px) => {
  const isPortrait = height > width;
  const shouldReturnOriginalAssetDimensions =
    (isPortrait && height > original_height_px)
    ||
    (!isPortrait && width > original_width_px);

  return shouldReturnOriginalAssetDimensions
    ? { safeWidth: original_width_px, safeHeight: original_height_px }
    : { safeWidth: width, safeHeight: height };
};

/*
 * For opener images and other images for which we do not know the original
 * asset size, we should not return an image that's larger than 2000px
 * on any side.
 */
export const getSafeDimensionsForOpener = (width, height) => {
  const ratio = width / height;
  const isPortrait = ratio < 1.0;

  if (isPortrait && height > 2000) {
    return {
      safeWidth: 2000 * ratio,
      safeHeight: 2000
    };
  }

  if (!isPortrait && width > 2000) {
    return {
      safeWidth: 2000,
      safeHeight: 2000 / ratio
    };
  }

  return { safeWidth: width, safeHeight: height };
};

export const getProportionalHeight = (width, { original_width_px, original_height_px }) => {
  return width * original_height_px / original_width_px;
};

export const getProportionalWidth = (height, { original_width_px, original_height_px }) => {
  return height * original_width_px / original_height_px;
};

export const getMainAssetAltText = (asset_main, opener_images) => get(
  find(opener_images, (opener) => {
    const src = get(opener, 'asset.src.full', '');
    return src.includes(asset_main.id) && Boolean(get(opener, 'alt_title', ''));
  }),
  'alt_title',
  null
);
